<template>
  <div>
    <Datepicker
      v-model="dataParam"
      :format="DatePickerFormat"
      :language="languages[language]"
      :monday-first=true
      :maximum-view="'day'"
      :minimum-view="'day'"
      :initial-view="'day'"
      input-class="calender-text-box"
      :highlighted="highlighted"
      placeholder="YYYY/MM/DD"
      :disabled-dates="disabledDates"
    />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import * as all_lang from 'vuejs-datepicker/dist/locale'; // 全言語を取得

export default {
  components: {
    Datepicker
  },
  props: {
    language: {
      type: String,
      default: 'en' // 初期値：英語
    },
    value: {
      type: Date,
      default:''
    },
    limitDay: {
      type: Date,
      default:''
    }
  },
  data() {
    return {
      languages: all_lang,
      DatePickerFormat: 'yyyy/MM/dd', //カレンダーのフォーマット
      highlighted: {
        dates: [ // Highlight an array of dates
          new Date(),
        ],
      },
      disabledDates: {
          to: this.limitDay,
          from: new Date(),
      }
    };
  },
  computed: {
    dataParam: {
      get() {
//console.log(this.disabledDates);
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  }
};
</script>

<style>
.calender-text-box {
  text-align: center;
  width: 100px;
}
</style>
